import { withApiErrorResponse } from "../utils/apiError";

export const checkedStoreResponse = (response) => {
  const data = response.data;
  if ((data?.header?.code != null && Number(data.header.code) !== 600) || data?.success === false) {
    const message = [data?.body?.value, data?.body?.error, data?.header?.message, data?.message]
      .find((value) => typeof value === "string" && value.trim());
    const error = new Error(message || "Unable to save or load the store.");
    error.response = response;
    throw withApiErrorResponse(error);
  }
  return data;
};

export const storeListFromResponse = (response) => {
  const value = response?.body?.value ?? response?.data ?? response;
  const list = Array.isArray(value) ? value : [value?.storeList, value?.stores, value?.content, value?.items].find(Array.isArray);
  if (!list) throw new Error("Unable to read the store list response.");
  return list;
};
